
export function ellipseAddress(
  address: string = "",
  width: number = 4
): string {
  return `${address.slice(0, width + 2)}...${address.slice(-width)}`;
}